import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  chartData: any[] = [];
  view: [number, number] = [800, 400];

  // Chart options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = true;
  showYAxisLabel = true;
  xAxisLabel = 'Store Name';
  yAxisLabel = 'Total Amount';
  colorScheme = {
    domain: ['#4CAF50', '#2196F3', '#FF9800', '#E91E63', '#9C27B0', '#00BCD4', '#FFC107']
  };

  from: string;
  to: string;

  constructor(public appservice: AppService, private datePipe: DatePipe) {
    // Default: current month range
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    this.from = this.datePipe.transform(firstDay, 'yyyyMMdd')!;
    this.to = this.datePipe.transform(lastDay, 'yyyyMMdd')!;
  }

  ngOnInit(): void {
    this.loadStoreWiseSales();
  }

  loadStoreWiseSales() {
    const url = `Api/transaction/GetDateWiseSales?FromDt=${this.from}&ToDt=${this.to}`;
    
    this.appservice.get(url).subscribe({
      next: (res: any) => {
        try {
          const parsed = JSON.parse(res);
          const records = parsed.record || parsed;

          this.chartData = records.map((r: any) => ({
            name: r['Store Name'],
            value: parseFloat(r['Total']) || 0
          }));

          console.log('Chart Data:', this.chartData);
        } catch (err) {
          console.error('Invalid data format', res);
        }
      },
      error: (err) => {
        console.error('API Error:', err);
      }
    });
  }
}
